const quoteFormDefaultValues = {
  order_data: {
    pickup: {
      date: '',
      time_from: '',
      time_to: '',
    },
    dropoff: {
      date: '',
      time_from: '',
      time_to: '',
    },
  },
  price: {
    amount: '',
    currency: 'EUR',
  },
  suggested_price: {
    amount: '0',
    currency: 'EUR',
  },
  operation_details: {
    carrier: '',
    cost: {
      amount: '',
      currency: 'EUR',
    },
    details: '',
  },
  quote_costs: [
    {
      carrier: {
        name: '',
      },
      cost: {
        amount: '',
        currency: 'EUR',
      },
      bid_id: null,
      comments: '',
    },
  ],
  expiration_time: '',
  expiration_date: '',
  conditions: '',
  price_suggestion_id: null,
};

export default quoteFormDefaultValues;
